<template>
    <v-list class="sidebar-geography">
        <v-list-item>
            <geography-selector></geography-selector>
        </v-list-item>
    </v-list>
</template>

<script>
    import GeographySelector from './GeographySelector.vue';

    export default {
        name: "sidebar-geography",
        components: { GeographySelector },
    }
</script>